export enum ActionTypes {
  REQUEST = "@tamanho-papeis/REQUEST",
  SUCCESS = "@tamanho-papeis/SUCCESS",
  FAILURE = "@tamanho-papeis/FAILURE",
}
